import { HttpParams } from '@angular/common/http';

export type HttpParamsInput = Record<string, string | number | boolean | undefined | null>;

export function toHttpParams(params: HttpParamsInput): HttpParams {
  return Object.entries(params).reduce((acc, [key, value]) => {
    if (value === undefined || value === null || value === '') {
      return acc;
    }
    return acc.set(key, value);
  }, new HttpParams());
}
